import $ from "jquery";
import { manageTermsAndConditions } from "./manage-terms-and-conditions";

const cartItemsSelector = "cart-items";
const cartCollectionsQtyStatusDataSelector =
  "#cart-collections-qty-status-data";

export const updateCart = async (
  response: Response,
  line: string,
  name: string | undefined,
) => {
  try {
    const parsedState = await response.json();
    const quantityElement = document.getElementById(
      `Quantity-${line}`,
    ) as HTMLInputElement;
    const items = document.querySelectorAll(".cart-item");

    if (!response.ok && parsedState.message && quantityElement) {
      quantityElement.value = quantityElement.getAttribute("value") ?? "";
      handleLineErrors(line, parsedState.message);
      return;
    }

    // handle is-empty class
    const $cartItems = $(cartItemsSelector).first() as JQuery<HTMLElement>;
    $cartItems[0]?.classList.toggle("is-empty", parsedState.item_count === 0);
    const cartFooter = document.getElementById("main-cart-footer");
    if (cartFooter) {
      cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
    }

    const sections = getSectionsToRender();
    for (const section of sections) {
      if (!section) {
        continue;
      }
      const elementToReplace =
        document.getElementById(section.id)?.querySelector(section.selector) ||
        document.getElementById(section.id);
      if (elementToReplace && section.section) {
        elementToReplace.innerHTML =
          new DOMParser()
            .parseFromString(parsedState.sections[section.section], "text/html")
            ?.querySelector(section.selector)?.innerHTML ?? "";
      }
    }

    const updatedValue = parsedState.items[parseInt(line) - 1]
      ? parsedState.items[parseInt(line) - 1].quantity
      : undefined;
    let message = "";
    if (
      items.length === parsedState.items.length &&
      updatedValue !== parseInt(quantityElement.value)
    ) {
      if (typeof updatedValue === "undefined") {
        message = window.cartStrings.error;
      } else {
        message = window.cartStrings.quantityError.replace(
          "[quantity]",
          updatedValue,
        );
      }
    }

    handleLineErrors(line, message);

    if (name) {
      const lineItem = document.getElementById(`CartItem-${line}`);
      if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
        (
          lineItem.querySelector(`[name="${name}"]`) as HTMLInputElement
        )?.focus();
      }
    }
  } catch (e) {
    console.log(e);
  } finally {
    manageTermsAndConditions();
  }
};

export const handleLineErrors = (line: string, message: string) => {
  const lineItemError = document.getElementById(`Line-item-error-${line}`);
  if (lineItemError) {
    const cartItemErrorText = lineItemError.querySelector(
      ".cart-item__error-text",
    );
    if (cartItemErrorText) {
      cartItemErrorText.innerHTML = message;
    }
  }
  const lineItemStatusElement = document.getElementById(
    "shopping-cart-line-item-status",
  );
  if (lineItemStatusElement) {
    $(lineItemStatusElement).prop("aria-hidden", true);
  }
  const cartStatus = document.getElementById("cart-live-region-text");
  if (cartStatus) {
    $(cartStatus).prop("aria-hidden", false);
    setTimeout(() => {
      $(cartStatus).prop("aria-hidden", true);
    }, 1000);
  }
};

export const getSectionsToRender = () => {
  return [
    {
      id: "main-cart-items",
      section: document.getElementById("main-cart-items")?.dataset.id,
      selector: ".js-contents",
    },
    {
      id: "cart-icon-bubble",
      section: "cart-icon-bubble",
      selector: ".shopify-section",
    },
    {
      id: "cart-live-region-text",
      section: "cart-live-region-text",
      selector: ".shopify-section",
    },
    {
      id: "main-cart-footer",
      section: document.getElementById("main-cart-footer")?.dataset.id,
      selector: ".js-contents",
    },
  ];
};

export const checkCartCollectionsQtyLimits = (collection_id_list: string) => {
  // check if the product belongs to a collection which has not reached its limit in the cart
  const result: {
    exceeded: boolean;
    qtyLimit: number | null;
  } = {
    exceeded: false,
    qtyLimit: null,
  };
  try {
    const cartCollectionsQtyStatusData = $(
      cartCollectionsQtyStatusDataSelector,
    ).data("collections");
    const productCollectionIdList = collection_id_list.toString().split(",");
    result.exceeded = !productCollectionIdList.every((id) => {
      const collection = cartCollectionsQtyStatusData.find(
        (collection: { id: string }) => collection.id === id,
      );
      if (!collection) {
        // no collection found results in no limitation
        return true;
      }
      const check = collection.item_count < collection.max_quantity;
      if (!check) {
        result.qtyLimit = collection.max_quantity;
      }
      return check;
    });
    return result;
  } catch (e) {
    return result;
  }
};
